export enum InterfaceTopic {
    termOfPayment = "termOfPayment",
    customer = "customer",
    project = "project",
    priceList = "priceList",
    productGroup3 = "productGroup3",
    productGroup6 = "productGroup6",
    country = "country",
    assetCategory = "assetCategory",
    outgoingInvoice = "outgoingInvoice",
    salesOrder = "salesOrder",
    orderType = "orderType",
    employee = "employee",
    termOfDelivery = "termOfDelivery",
    article = "article",
    invoice = "invoice"
}

export enum InterfaceType {
    read = "read",
    write = "write",
    adhoc = "adhoc",
}

export enum ConnectedSystem {
    baan3 = "baan3",
    baan4 = "baan4",
    infor = "infor",
    emtDwh = "emtDwh",
}

export interface IGetInterfaceStatusDto {
    topic: InterfaceTopic
    type: InterfaceType
    description?: string
    connectedSystem?: ConnectedSystem
    isConnected?: boolean
}

export default class InterfaceStatus {
    topic: InterfaceTopic
    type: InterfaceType
    description?: string
    connectedSystem?: ConnectedSystem
    isConnected: boolean

    constructor(dto: IGetInterfaceStatusDto) {
        this.topic = dto.topic
        this.type = dto.type
        this.description = dto.description
        this.connectedSystem = dto.connectedSystem
        this.isConnected = dto.isConnected || false
    }

    printConnectedSystem(): string {
        if (!this.connectedSystem) return ""
        return this.connectedSystem.charAt(0).toUpperCase() + this.connectedSystem.slice(1);
    }
}
